import type { Environment } from './types';

// 生产环境配置
const prodEnvironment: Environment = {
  featureTag: '',
  AMSCashierPaymentEnvironment: 'prod',
  officialWebsite: 'https://www.groupbuyth.com',
  // 生产环境：30天
  serviceRatingTimeLimit: 30 * 24 * 60 * 60 * 1000,
  h5Url: 'https://www.groupbuyth.com',
};

export default prodEnvironment;
